import React, { useEffect, useState } from "react";
export const ClientRendered = ({ children }) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    if (!isMounted) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=ClientRendered.js.map